import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-width full-height min-height io-mfe-ig-procedure-table flex" }

import { ref, reactive } from 'vue';
import {storeToRefs} from 'pinia';
import ProcedureColumn from 'components/search/procedure/ProcedureColumn.vue';
import { ProcedureColumnItem, useSearchStore } from 'stores/search-store';
import { isEmpty } from 'src/common/arrayUtil';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcedureTable',
  setup(__props) {

const searchStore = useSearchStore();
const { searchTable } = storeToRefs(searchStore);
const defaultPercents = [
  14.29, // 14.29 percent of total area for each split
  16.67, // 14.29/85.71 = 16.67
  20, // 14.29/71.42 = 20
  25, // 14.29/57.13 = 25
  33.36, // 14.29/42.84 = 33.36
  50 // 14.29/28.55 = ~50
];

const splitterModels = reactive(defaultPercents.map((percent) => ref(percent)));

function getColumn(index: number) {

  return searchTable.value?.columns.find((col => col.index == index));
}

function getOptions(index: number) {
  const options = getColumn(index)?.choices || [];
  return options.filter(item => {
    const code = searchStore.getSelectedProcedureCode.toLowerCase();
    return searchStore.getSelectedProcedureCode
      && searchStore.getSelectedProcedureCode.length >= index
      && item
      && !isEmpty(item.prefixes)
      && item.prefixes?.some(prefix => matchesPrefix(code, prefix.toLowerCase()));
  });
}

function matchesPrefix(code: string, prefix: string): boolean {

  for (let i=0; i< prefix.length;i++) {
    const char = prefix[i];
    if (char != '*' && char != code[i]) {
      return false;
    }
  }

  return true;
}

async function optionSelected(index: number, option: ProcedureColumnItem) {

  await searchStore.setSelectedProcedureCode(searchStore.getSelectedProcedureCode.substring(0, index) + option.char);

  if (index != 6) {
    const nextOptions = getOptions(index + 1);
    if (!isEmpty(nextOptions) && nextOptions.length == 1) {
      optionSelected(index + 1, nextOptions[0]);
    }
  }
}

function isActive(index: number) {
  return searchStore.getSelectedProcedureCode.length == index;
}

function isItemSelected(index: number, item: ProcedureColumnItem) {
  return searchStore.getSelectedProcedureCode?.[index] == item.char;
}


return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_splitter, {
      modelValue: splitterModels[0].value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((splitterModels[0].value) = $event))
    }, {
      before: _withCtx(() => [
        _createVNode(ProcedureColumn, {
          title: _unref(searchStore).getPcsSectionColumn?.header,
          items: _unref(searchStore).getPcsSectionColumn?.choices,
          onOptionClicked: _cache[0] || (_cache[0] = (option) => optionSelected(0, option)),
          active: isActive(0),
          "is-item-selected": item => isItemSelected(0, item)
        }, null, 8, ["title", "items", "active", "is-item-selected"])
      ]),
      after: _withCtx(() => [
        _createVNode(_component_q_splitter, {
          modelValue: splitterModels[1].value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((splitterModels[1].value) = $event))
        }, {
          before: _withCtx(() => [
            _createVNode(ProcedureColumn, {
              title: getColumn(1)?.header,
              items: getOptions(1),
              onOptionClicked: _cache[1] || (_cache[1] = (option) => optionSelected(1, option)),
              active: isActive(1),
              "is-item-selected": item => isItemSelected(1, item)
            }, null, 8, ["title", "items", "active", "is-item-selected"])
          ]),
          after: _withCtx(() => [
            _createVNode(_component_q_splitter, {
              modelValue: splitterModels[2].value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((splitterModels[2].value) = $event))
            }, {
              before: _withCtx(() => [
                _createVNode(ProcedureColumn, {
                  title: getColumn(2)?.header,
                  items: getOptions(2),
                  onOptionClicked: _cache[2] || (_cache[2] = (option) => optionSelected(2, option)),
                  active: isActive(2),
                  "is-item-selected": item => isItemSelected(2, item)
                }, null, 8, ["title", "items", "active", "is-item-selected"])
              ]),
              after: _withCtx(() => [
                _createVNode(_component_q_splitter, {
                  modelValue: splitterModels[3].value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((splitterModels[3].value) = $event))
                }, {
                  before: _withCtx(() => [
                    _createVNode(ProcedureColumn, {
                      title: getColumn(3)?.header,
                      items: getOptions(3),
                      onOptionClicked: _cache[3] || (_cache[3] = (option) => optionSelected(3, option)),
                      active: isActive(3),
                      "is-item-selected": item => isItemSelected(3, item)
                    }, null, 8, ["title", "items", "active", "is-item-selected"])
                  ]),
                  after: _withCtx(() => [
                    _createVNode(_component_q_splitter, {
                      modelValue: splitterModels[4].value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((splitterModels[4].value) = $event))
                    }, {
                      before: _withCtx(() => [
                        _createVNode(ProcedureColumn, {
                          title: getColumn(4)?.header,
                          items: getOptions(4),
                          onOptionClicked: _cache[4] || (_cache[4] = (option) => optionSelected(4, option)),
                          active: isActive(4),
                          "is-item-selected": item => isItemSelected(4, item)
                        }, null, 8, ["title", "items", "active", "is-item-selected"])
                      ]),
                      after: _withCtx(() => [
                        _createVNode(_component_q_splitter, {
                          modelValue: splitterModels[5].value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((splitterModels[5].value) = $event))
                        }, {
                          before: _withCtx(() => [
                            _createVNode(ProcedureColumn, {
                              title: getColumn(5)?.header,
                              items: getOptions(5),
                              onOptionClicked: _cache[5] || (_cache[5] = (option) => optionSelected(5, option)),
                              active: isActive(5),
                              "is-item-selected": item => isItemSelected(5, item)
                            }, null, 8, ["title", "items", "active", "is-item-selected"])
                          ]),
                          after: _withCtx(() => [
                            _createVNode(ProcedureColumn, {
                              title: getColumn(6)?.header,
                              items: getOptions(6),
                              onOptionClicked: _cache[6] || (_cache[6] = (option) => optionSelected(6, option)),
                              active: isActive(6),
                              "is-item-selected": item => isItemSelected(6, item)
                            }, null, 8, ["title", "items", "active", "is-item-selected"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})